import React, { useEffect } from "react"
import { FormattedMessage } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { useProposalEmails } from "../../common/hooks"
import LoadingSpinner from "../../common/spinner/loading.component"
import { CommunicationSectionProps } from "../../common/types/project"
import InternalNotes from "../../order/internalnotes.component"
import AnalyticsQuoteEmails from "../../quote/analytics/quoteemails.component"
import { StockDocumentSelector } from "../../state/inventory/stockdocument/selectors"
import { ProjectAction, ProjectSelector } from "../../state/project"
import { ProposalAction } from "../../state/proposal/actions"
import { ProposalSelector } from "../../state/proposal/selectors"

export const CommunicationSection = (props: CommunicationSectionProps) => {
    const project = useSelector(ProjectSelector.get)
    const proposal = useSelector(ProposalSelector.getStructured)
    const { emails } = useProposalEmails(proposal.id, proposal.attributes.emailSent)
    const emailId = useSelector(StockDocumentSelector.getEmailTemplateId)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!proposal.attributes.isLoading && !proposal.attributes.isLoaded) {
            dispatch(ProposalAction.fetch(props.proposalHash))
        }
    }, [])

    if (!proposal.attributes.isLoaded) {
        return <LoadingSpinner/>
    }

    return (
        <div className={"col-12 px-4"}>
            <div className={"row"}>
                <div className="col-12 ui-module">
                    <div className={"row"}>
                        <div className={`col-12 col-md-6 ${props.showEmailSection && "border-right"}`}>
                            <InternalNotes
                                projectObject={project}
                                internalNotes={project.internalNotes}
                                onRefresh={() => {
                                    dispatch(ProjectAction.fetch(project.id))
                                }}
                            />
                        </div>

                        {props.showEmailSection &&
                            <div className={"col-12 col-md-6 "}>

                                <div className={"w-100"}>
                                    <label className="col-form-label custom-form-label pt-0">
                                        <strong>
                                            <FormattedMessage
                                                id="invoice.analytics.emails_label"
                                                defaultMessage="Emails"
                                            />
                                        </strong>
                                    </label>
                                </div>
                                <AnalyticsQuoteEmails
                                    templateId={emailId}
                                    onChange={prop => dispatch(ProposalAction.set(prop))}
                                    project={project}
                                    proposal={proposal}
                                    emails={emails}
                                    isEditable={true}
                                />
                            </div>
                        }
                    </div>
                </div>

            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/project/sections/CommunicationSection.tsx